import { render } from "./PinguPCZ.vue?vue&type=template&id=508c275e"
import script from "./PinguPCZ.vue?vue&type=script&lang=js"
export * from "./PinguPCZ.vue?vue&type=script&lang=js"

import "./PinguPCZ.vue?vue&type=style&index=0&id=508c275e&lang=css"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__